import { fromEnumAsString } from '../../../serialization/enum-utils.js';
import { DataModel, DataModelBuilder, SerializationContext, SerializedData } from '../../dto/dto.js';
import { EventBookingProtocol } from './event-booking-protocol.js';
import { EventBookingStrategy } from './event-booking-strategy.js';

export class CalendarEventBookingProtocol extends EventBookingProtocol {
  static readonly TYPE_ID: string = '9a3bdc979d474f178a83d094cd9e4ecc';

  public readonly strategy: EventBookingStrategy = EventBookingStrategy.Calendar;

  private constructor() {
    super();
  }

  get $typeId(): string {
    return CalendarEventBookingProtocol.TYPE_ID;
  }

  static create(): CalendarEventBookingProtocol {
    return new CalendarEventBookingProtocol();
  }

  static fromMap(context: SerializationContext, map: SerializedData): CalendarEventBookingProtocol {
    return new CalendarEventBookingProtocol();
  }

  toMap(context: SerializationContext): SerializedData {
    return {
      'strategy': fromEnumAsString(this.strategy),
    };
  }

  clone(): this {
    return new CalendarEventBookingProtocol() as this;
  }

  isSame(other: CalendarEventBookingProtocol): boolean {
    if(this === other) {
      return true;
    }

    return other.strategy === this.strategy;
  }

  static verifyType(order: DataModel): boolean {
    return order instanceof CalendarEventBookingProtocol;
  }

  static assertType(order: DataModel): order is CalendarEventBookingProtocol {
    return order instanceof CalendarEventBookingProtocol;
  }
}

export class CalendarEventBookingProtocolBuilder extends DataModelBuilder<CalendarEventBookingProtocol> {
  build(context: SerializationContext, map: SerializedData): CalendarEventBookingProtocol {
    return CalendarEventBookingProtocol.fromMap(context, map);
  }
}
